<div class="status-tag" [ngStyle]="getTagStyles()">
  <div class="status-header" [ngStyle]="getHeaderStyles()">
    @if (iconSvgPath) {
      <img
        [src]="iconSvgPath | iconPath"
        [alt]="label | translate"
      />
    }

    @if (piIcon) {
      <i
        [class]="'pi ' + piIcon + ' status-icon'"
        [ngStyle]="{ color: getIconColor() }">
      </i>
    }

    <span class="status-label" [ngStyle]="{ color: getLabelColor() }">{{ label | translate }}</span>
  </div>

  <div class="status-content">
    @if (title) {
      <div class="status-title">{{ title }}</div>
    }

    @if (description) {
      <div class="status-description">{{ description }}</div>
    }

    @if (date || time) {
      <div class="status-datetime">
        @if (date) {
          <span>{{ date }}</span><br/>
        }
      </div>
      <div class="status-datetime">
      @if (time) {
          <span> {{ time }}</span>
        }
      </div>
    }
  </div>
</div>
